import React, { use, useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
} from "reactstrap"
import * as Yup from "yup"
import Select from "react-select";

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import AppointmentTable from "./AppointmentTable"
import { dateFormat, dateTimeFormat, dateTimeFormat1, dateTimeFormatIOS } from "pages/Common"
import CreateAppointmentModel from "./CreateAppointmentModel"
import ErrorModel from "common/errorModel/errorModel"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}
function AppointmentList() {
    document.title = `Appointments | Raja Rani Couture`
    let { pathname } = useLocation()
    let { state } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    // useStates
    const [modal, setModal] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [isEdit, setIsEdit] = useState(false)
    const [isCreate, setIsCreate] = useState(false)
    const [editData, setEditData] = useState()
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(state == null ? true : false)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])


    // filter data for task-title
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // task-title list api
    const AppointmentListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Appointment/list", {
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
            HandleBy: parseInt(userFilter),
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data.AppointmentList)
                setTotalRecords(data.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // task-title list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            AppointmentListApi()
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, dateDisble, dateFilter])


    // Create task-title handler
    const handleAppointmentClick = () => {
        toggle()
        setIsEdit(false)
        setIsCreate(true)
    }

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        // if (!modal) {
        //     setIsEdit(false)
        // }
    }

    const handleEdit = (data) => {
        setEditData(data)
        setIsEdit(true)
        setIsCreate(false)
        toggle()
    }

    const handleDelete = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this appointment permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Appointment/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Appointment deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Appointment",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Name",
                accessor: "Name",
                width: "10%"
            },
            {
                Header: "Contact#",
                accessor: "ContactNo",
                width: "7%"
            },
            {
                Header: () => (
                    <div style={{ textAlign: "center" }} className="text-wrap">
                        Appointment Time
                    </div>
                ),
                accessor: "AppointmentTime",
                width: "5%",
                Cell: ({ row }) => {
                    return (
                        <>
                            < p className=" mb-0 text-wrap" >
                                {
                                    row.original.AppointmentTime == "0001-01-01T00:00:00"
                                        ? "N/A"
                                        : dateTimeFormat(row.original.AppointmentTime, "dd-MM-yyyy HH:mm tt")
                                }
                            </p >
                        </>
                    )
                },
            },
            {
                Header: "Handle By",
                accessor: "HandleByName",
                width: "9%"
            },
            {
                Header: "Address",
                accessor: "Address",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Address}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Remark",
                accessor: "Remark",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Remark}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedByName}
                    </p>
                ),
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original.CreatedOn.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "5%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEdit(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>

                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Name", "Contact#", "Appointment Time", "Handle By", "Address", "Remark", "Created By", "Created On"];
            const mainTitle = "Appointment";
            const widthObj = [{
                Key: "A",
                Value: 20,
            },
            {
                Key: "B",
                Value: 15,
            },
            {
                Key: "C",
                Value: 20,
            },
            {
                Key: "D",
                Value: 18,
            },
            {
                Key: "E",
                Value: 25,
            },
            {
                Key: "F",
                Value: 25,
            },
            {
                Key: "G",
                Value: 15,
            },
            {
                Key: "H",
                Value: 15,
            },
            ]
            const extention = "Appointment.xlsx"
            let excelSheetData = []

            postApi("Appointment/list", {
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
                HandleBy: parseInt(userFilter),
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.AppointmentList.length; index++) {
                        let dataObj = {
                            Name: data?.AppointmentList[index].Name,
                            ContactNo: data?.AppointmentList[index].ContactNo,
                            AppointmentTime: data?.AppointmentList[index].AppointmentTime == "0001-01-01T00:00:00"
                                ? "N/A"
                                : dateTimeFormat(data?.AppointmentList[index].AppointmentTime, "dd-MM-yyyy HH:mm tt"),
                            HandleBy: data?.AppointmentList[index].HandleByName,
                            Address: data?.AppointmentList[index].Address,
                            Remark: data?.AppointmentList[index].Remark,
                            CreatedOn: data?.AppointmentList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.AppointmentList[index].CreatedOn, "dd-MM-yyyy"),
                            CreatedByName: data?.AppointmentList[index].CreatedByName,
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })
            setIsLoading(false)
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <AppointmentTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddAppointmentList={true}
                            handleAppointmentClick={handleAppointmentClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            writeDataToExcel={writeDataToExcel}
                        />

                        {(isCreate || isEdit) &&
                            <CreateAppointmentModel
                                modal={modal}
                                toggle={toggle}
                                isEdit={isEdit}
                                editData={isEdit ? editData : ''}
                                AppointmentListApi={AppointmentListApi}
                                AssignByData={''}
                            />
                        }

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
AppointmentList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default AppointmentList
